export default __webpack_public_path__ + "static/ilustration-about-4-773aeafe5cf86b648455fc9a7a5c7dff.png";